import * as types from '@/store/mutation-types'
import { find, findIndex } from 'lodash'
import moment from 'moment'
import apolloClient from '@/api/apollo'
import EventsSubscribersClient from '@/api/events'

import VEHICLES_QUERY from '@/graphql/queries/Tracking/FetchVehicles.graphql'
import FETCH_VEHICLE_LAST_EVENT from '@/graphql/queries/Tracking/FetchVehicleLastEvent.graphql'

const eventsClient = new EventsSubscribersClient()
const module = {
  namespaced: true,
  state: {
    events: [],
    vehicles: []
  },
  getters: {
    events: state => {
      return state.events.map(event => {
        return {
          _id: event._id,
          name: event.name,
          date: moment(event.gpsDate).fromNow(),
          highPriority: event.highPriority
        }
      })
    }
  },
  mutations: {
    [types.UNSHIFT_EVENT] (state, { event }) {
      state.events = [event, ...state.events]
    },
    [types.SET_EVENTS] (state, { events }) {
      state.events = events
    },
    [types.UPDATE_POSITION] (state, { position }) {
      const vehicle = find(state.vehicles, { _id: position.vehicleId })
      const vehicleIndex = findIndex(state.vehicles, { _id: position.vehicleId })
      if (!vehicle || vehicleIndex === -1) throw new Error('Vehicle not found in store')
      vehicle.position = { lat: position.lat, lng: position.lng }
      state.vehicles.splice(vehicleIndex, 1, vehicle)
    },
    [types.SET_VEHICLES] (state, { vehicles }) {
      state.vehicles = vehicles.map(vehicle => {
        let position
        if (vehicle.lastEvent && vehicle.lastEvent.data && vehicle.lastEvent.data.gps) {
          position = {
            lat: vehicle.lastEvent.data.gps.latitude || 0,
            lng: vehicle.lastEvent.data.gps.longitude || 0
          }
        }
        return {
          _id: vehicle._id,
          plate: vehicle.plate,
          position
        }
      })
    }
  },
  actions: {
    connectToEventsServer ({ commit }) {
      return new Promise((resolve, reject) => {
        eventsClient.connect()
        eventsClient.once('connection', event => {
          if (process.env.NODE_ENV === 'development') {
            console.log('Connected to events subscribers server')
          }
          return resolve(event)
        })
      })
    },
    subscribeToEvents ({ commit }) {
      eventsClient.subscribe()
      eventsClient.on('event', event => {
        commit(types.UNSHIFT_EVENT, { event })
      })
      eventsClient.on('position', position => {
        commit(types.UPDATE_POSITION, { position })
      })
    },
    unsubscribeFromEvents ({ commit }) {
      eventsClient.unsubscribe()
      eventsClient.removeAllListeners()
    },
    watchVehicle (context, { vehicleId }) {
      eventsClient.watchVehicle(vehicleId)
    },
    async fetchVehicles ({ commit }) {
      const result = await apolloClient.query({
        query: VEHICLES_QUERY
      })
      const vehicles = result.data.fetchVehicles
      commit(types.SET_VEHICLES, { vehicles })
    },
    async fetchVehicleLastEvent ({ commit }, { vehicleId }) {
      const result = await apolloClient.query({
        query: FETCH_VEHICLE_LAST_EVENT,
        variables: {
          vehicleId
        }
      })
      const lastEvent = result.data.fetchVehicleById.lastEvent
      if (!lastEvent) {
        commit(types.SET_EVENTS, { events: [] })
        throw new Error('No se encontró el último evento del vehículo')
      }
      commit(types.SET_EVENTS, {
        events: [{
          _id: lastEvent._id,
          gpsDate: lastEvent.data.gps.date,
          name: lastEvent.name,
          highPriority: lastEvent.highPriority
        }]
      })
    }
  }
}

export default module



// WEBPACK FOOTER //
// ./src/store/modules/tracking/index.js